import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import BasicDetailsFormSkeleton from "./BasicDetailsFormSkeleton"
const ProfileCompletionProgressSkeleton = () => {
    return (
        <div className="w-80 bg-flup-surface border-r border-flup-hairline h-screen overflow-y-auto">
            <div className="p-6">
                {/* Header with Logo */}
                <div className="flex items-center space-x-3 mb-6">
                    <Skeleton className="w-8 h-8 rounded-lg" />
                    <Skeleton className="h-5 w-32" />
                </div>

                {/* Title Section */}
                <div className="mb-6 space-y-2">
                    <Skeleton className="h-6 w-48" />
                    <Skeleton className="h-4 w-64" />
                </div>

                {/* Progress Steps */}
                <div className="space-y-4">
                    {[1, 2, 3].map((_, index) => (
                        <div key={index} className="flex items-start space-x-4">
                            <div className="flex flex-col items-center">
                                <Skeleton className="w-8 h-8 rounded-full" />
                                {index < 2 && <Skeleton className="w-0.5 h-12 mt-2" />}
                            </div>
                            <div className="flex-1 space-y-2">
                                <Skeleton className="h-5 w-40" />
                                <Skeleton className="h-4 w-56" />
                            </div>
                        </div>
                    ))}
                </div>

                {/* Progress Bar */}
                <div className="mt-8 space-y-3">
                    <div className="flex justify-between">
                        <Skeleton className="h-4 w-24" />
                        <Skeleton className="h-4 w-10" />
                    </div>
                    <Skeleton className="h-2 w-full rounded-full" />
                    <Skeleton className="h-3 w-36" />
                </div>
            </div>
        </div>
    );
};


const VendorOnboardSkeleton = () => {

    return <div className="min-h-screen  bg-flup-canvas flex flex-col sm:flex-row">
        <div className='hidden sm:block'>
            <ProfileCompletionProgressSkeleton />

        </div>
        <div className="flex-1 flex items-center justify-center">
            <div className="w-96 sm:w-full max-w-4xl">

                <BasicDetailsFormSkeleton />

            </div>
        </div>
    </div>



    // return <div className="min-h-screen bg-flup-canvas flex">

    //     <ProfileCompletionProgressSkeleton />
    //     <div className="flex-1 flex items-center justify-center ">
    //         <div className="w-full max-w-2xl">
    //             <BasicDetailsFormSkeleton />
    //         </div>
    //     </div>
    // </div>


}

export default VendorOnboardSkeleton;